import { useState } from 'react';
// import { Button } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import firebase from 'firebase/compat/app';
import Message, { Type } from 'components/Notification/Message';
import { Input } from 'components/ui/input';
import { Button } from 'components/ui/button';

interface AuditTemplateTitleProps {
  templateTitle: string;
  isReadOnly: boolean;
  orgId: string;
  templateId: string;
}

function AuditTemplateTitle({
  templateTitle,
  isReadOnly,
  orgId,
  templateId,
}: AuditTemplateTitleProps) {
  const { t } = useTranslation();
  const [isEditingTitle, setIsEditingTitle] = useState(false);
  const [editedTitle, setEditedTitle] = useState(templateTitle);

  const handleSave = async () => {
    try {
      Message({
        key: 'updateAuditTemplateTitle',
        type: Type.LOADING,
        message: `Opdaterer skabelon titel`,
      });

      await firebase
        .firestore()
        .collection('orgs')
        .doc(orgId)
        .collection('auditTemplates')
        .doc(templateId)
        .set({ title: editedTitle }, { merge: true });

      Message({
        key: 'updateAuditTemplateTitle',
        type: Type.SUCCESS,
        message: `Skabelon titel blev opdateret`,
      });

      setIsEditingTitle(false);
    } catch (error) {
      console.error(error);
      Message({
        key: 'updateAuditTemplateTitle',
        type: Type.ERROR,
        message: `Der skete en fejl`,
        description: `Kunne ikke opdatere skabelon titel, prøv venligst igen`,
      });
    }
  };

  const handleCancel = () => {
    setEditedTitle(templateTitle);
    setIsEditingTitle(false);
  };

  if (isEditingTitle) {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          width: '100%',
          //   marginTop: 7,
          //   marginBottom: 10,
          //   marginLeft: -12,
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Input
          className="h-[48px]"
          style={{
            fontSize: 24,
            flexGrow: 1,
            fontWeight: 700,
          }}
          placeholder="Skabelon titel"
          value={editedTitle}
          onChange={(e) => setEditedTitle(e.target.value)}
          //   size="large"
          autoFocus
        />

        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
          }}
        >
          <div style={{ marginRight: 8 }} />
          <Button onClick={handleSave}>{t('audit.templates.edit.save')}</Button>
          <div style={{ marginRight: 8 }} />
          <Button variant="outline" onClick={handleCancel}>
            {t('audit.templates.edit.cancel')}
          </Button>
        </div>
      </div>
    );
  }

  return (
    <h1
      className="cursor-pointer px-2.5 py-1 bg-gray-50 border border-gray-100 rounded font-bold text-[24px] flex justify-between items-center w-full"
      onClick={() => {
        if (!isReadOnly) {
          setEditedTitle(templateTitle);
          setIsEditingTitle(true);
        }
      }}
    >
      <div>{templateTitle}</div>
      <Button disabled={isReadOnly} variant="ghost" size="icon">
        <EditOutlined />
      </Button>
    </h1>
  );
}

export default AuditTemplateTitle;
